// CACHE_BUST_MAIN: 2026-10-13 19:01:47
// FORCE_BUILD: 1791919580
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import './index.css';

 console.log('[BUILD] app boot v1791919580 | reload=2026-10-13 19:01:47');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
